import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import Loading from 'components/Loading/Loading';
import RelatorioColetasPorTransportador from './RelatorioColetasPorTransportador';
//Api
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import transportador_api from '../../../api/transportador_api';
import relatorio_api from '../../../api/relatorio_api';
//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';

//Context
import { useAuth } from '../../../context/auth';

//Estado inicial dos filtros do relatorio
function initialStateFiltros() {
    const dataAtual = new Date();
    dataAtual.setMonth(dataAtual.getMonth() - 1);
    const dataInicial = moment(dataAtual).format("YYYY-MM-DD");
    dataAtual.setMonth(dataAtual.getMonth() + 1);
    const dataFinal = moment(dataAtual).format("YYYY-MM-DD");
    return {
        dataInicial,
        dataFinal,
        modalidadeId: 0,
        modalidadeId_selected: null,
        transportadorId: 0,
        transportadorId_selected: null,
        status: "TODOS",
        nomeRelatorio: "Relatórios - Coletas por Transportador"
    }
}
export default function ColetasPorTransportador() {
    const { setupVariavel } = useAuth()
    //Estado que valida os possiveis erros nos campos de filtros
    const [errors, setErrors] = useState({});
    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
        objCampo({ name: "transportadorId_selected", required: true }),
    ]
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState();

    //Estado que guarda os valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Opções de modalidades de coleta
    const [optionsModalidades, setOptionsModalidades] = useState();

    //Opções de transportadores
    const [optionsTransportadores, setOptionsTransportadores] = useState();

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);

    //Opções do select de status
    const optionsStatus = [
        { value: "TODOS", text: "Todos" },
        { value: "COLETADO", text: "Coletado" },
        { value: "BAIXADO", text: "Recebido" },
        { value: "NÃO COLETADO", text: "Recusado" },
    ]

    //Variavel de navegação na tela
    const navigate = useNavigate();

    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Change para os campos modalidade e transportadores
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        });
    }

    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {

        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } })
            return;
        } else {
            setErrors({});
        }
        setLoading(true);
        relatorio_api.DetalhadoPorTransportador(filtros).then(response => {

            response.data.listaColetas = response.data.listaColetas.map(coleta => {
                coleta.placaImplemento = coleta.veiculo + " / " + coleta.tipo_Veiculo;
                Object.keys(coleta).map(value => {
                    if (!coleta[value]) {
                        coleta[value] = "Sem informação";
                    }
                });
                return coleta;
            });
            
            response.data.totalizadoresStatusModalidade = response.data.totalizadoresStatusModalidade.map(value => {
                value.titulo = value.titulo.replace("MTR", setupVariavel?.siglaDocumentoColeta)
                return value;
            });

            setDadosRelatorio(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null)
        })
            .finally(f => setLoading(false));
    }
    //Carrega as modalidades de coleta e os transportadores para o select
    useEffect(() => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setOptionsModalidades(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
        transportador_api.GetAll().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.fantasia };
            });
            setOptionsTransportadores(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }, []);
    if (dadosRelatorio != null) {
        return <RelatorioColetasPorTransportador dadosRelatorio={dadosRelatorio} btnVoltar={() => setDadosRelatorio(null)} filtros={filtros} />
    }
    return (
        <MainCard btnVoltarInTop={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Relatório detalhado por transportador</h4>
            <Row>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataInicial" label={"* Data inicial"} type={"date"} value={filtros.dataInicial} onChange={onChangeFiltros} invalid={!!errors.dataInicial} />
                    <PrintValidate field={"dataInicial"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataFinal" label={"* Data final"} type={"date"} value={filtros.dataFinal} onChange={onChangeFiltros} invalid={!!errors.dataFinal} />
                    <PrintValidate field={"dataFinal"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField placeholder='Selecione' name="modalidadeId_selected" label={"Modalidade"} type={"select"} searchable value={filtros.modalidadeId_selected} invalid={!!errors.modalidadeId_selected} onChange={onChangeSelected} options={optionsModalidades} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="transportadorId_selected" label={"* Transportador"} type={"select"} searchable value={filtros.transportadorId_selected} invalid={!!errors.transportadorId_selected} onChange={onChangeSelected} options={optionsTransportadores} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="status" label={"* Status"} type={"select"} value={filtros.status} invalid={!!errors.status} onChange={onChangeFiltros} options={optionsStatus} />
                </Col>
                <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                    <Button className='w-100 fw-bold' color='info text-light' onClick={carregarRelatorio}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    )
}